<template>
  <div>
    <v-row>
      <v-col cols="12">
        <text-field-like
            label="プロセス実装名"
            :value="processImplementationView.name"
            :value-id="processImplementationView.id">
        </text-field-like>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <text-field-like
            v-if="readonly"
            label="内部ID"
            :value="processImplementationView.localId"
            placeholder="未設定">
        </text-field-like>
        <v-text-field
            v-else
            label="内部ID"
            v-model="processImplementationView.localId"
            :rules="[v => !!v || '内部IDが必要です']"
            @change="handleChange"
            autofocus>
        </v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import {cloneDeep} from "lodash";
export default {
  name: "ProcessImplementationForm",
  components: {TextFieldLike},
  model: {
    prop: 'processImplementation',
    event: 'change'
  },
  props: {
    processImplementation: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      processImplementationView: {}
    };
  },
  methods: {
    handleChange() {
      this.$emit('change', cloneDeep(this.processImplementationView));
    },
  },
  watch: {
    processImplementation: {
      immediate: true,
      handler(processImplementation) {
        this.processImplementationView = cloneDeep(processImplementation) ?? {};
      }
    }
  }
}
</script>

<style scoped>

</style>
